// Vendors
import { useEffect, useState } from 'react';
// Constants
import { RESIZE_EVENT } from '../constants/cancel-drop-modal.constants';
// Handlers
import CancelDropModalHandlers from '../handlers/cancel-drop-modal.handlers';
// Types
import { CancelDropModalHookReturnType } from './types/cancel-drop-modal.hook.type';
// Utils
import { getModalMaxWidth } from '../utils/cancel-drop-modal.component.utils';

const CancelDropModalHook = (): CancelDropModalHookReturnType => {
  const [maxWidth, setMaxWidth] = useState(getModalMaxWidth());

  const { handleRecalculateWidth } = CancelDropModalHandlers({ setMaxWidth });
  
  useEffect(() => {
    window.addEventListener(RESIZE_EVENT, handleRecalculateWidth);
    return () => {
      window.removeEventListener(RESIZE_EVENT, handleRecalculateWidth);
    };
  }, []);
  
  return { maxWidth };
};

export default CancelDropModalHook;
